import { render, staticRenderFns } from "./patch1.2.vue?vue&type=template&id=317f1776&"
import script from "./patch1.2.vue?vue&type=script&lang=js&"
export * from "./patch1.2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports